import useMutationApi from '@/api/useMutationApi';

interface ReingestQuoteSheetRequest {
  quoteSheetId: string;
}

interface ReingestQuoteSheetResponse {
  success: boolean;
  quoteSheetId?: string;
  extractionResultId?: string;
  lineItemsCreated?: number;
  error?: string;
}

export function useReingestQuoteSheet({
  onSuccess,
}: {
  onSuccess?: (data: ReingestQuoteSheetResponse) => void;
} = {}) {
  return useMutationApi<ReingestQuoteSheetRequest, ReingestQuoteSheetResponse>({
    endpoint: 'accounts-payable/quote-sheet-matching/reingest-quote-sheet',
    method: 'POST',
    successMessage: 'Reingest started',
    errorMessage: 'Failed to reingest quote sheet',
    showSuccessToast: true,
    showErrorToast: true,
    options: {
      onSuccess: (data) => {
        onSuccess?.(data.data);
      },
    },
  });
}
